<div *ngIf="global_texts && mod_info_presentation" class="all-content">
  <div class="">
    <app-header></app-header>
  </div>
  <div class="content">
    <div class="inner-content">

      <div class="sidebar-content">
        <app-sidebar></app-sidebar>
      </div>

      <div>
        <div class="mt-5 mt-md-3 p-3 p-lg-5">
          <div class="d-flex">

            <div class="self-module mod-intro">
              <div class="bubble-step right mb-5">

                <!-- Bubble Content -->
                <div class="d-block d-lg-flex justify-content-between align-items-end gap-4 pb-3">
                  <!--old class : bloc-image-->
                  <div class="left-module smaller text-start">
                    <img [src]="mod_info_presentation.image" class="image-intro"/>
                    <h1 class="color-red text-uppercase fw-bold text-start mt-4"
                        [innerHtml]="mod_info_presentation.title"></h1>
                    <div class="title-sep bg-red"></div>
                    <h3 class="color-green fw-bold" [innerHtml]="mod_info_presentation.subtitle"></h3>
                  </div>
                  <div class="right-module border-start border-4 bd-color-red py-0 px-4 text-start">
                    <h3 class="color-green text-uppercase fw-bold" [innerHtml]="mod_info_presentation.text_title"></h3>
                    <h5 class="text-bubble-step text-start mt-4" [innerHtml]="mod_info_presentation.text"></h5>
                    <div class="mt-5 d-flex gap-3 align-items-center" *ngIf="mod_info_presentation.time">
                      <img src="/assets/images/icons/time.svg" style="width: 45px;">
                      <div class="fw-bold color-red" [innerHtml]="mod_info_presentation.time"></div>
                    </div>
                  </div>
                </div>

                <div>
                  <!-- Button -->
                  <div class="mt-5 mx-auto text-center">
                    <button class="btn btn-solid-green text-uppercase"
                            (click)="app.sharedHelper.goToNextScreen()"
                            [innerHtml]="global_texts.start">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <app-footer></app-footer>
    </div>
  </div>
</div>
